<template>
	<sf-data-table
		ref="partsInfoTable"
		paging
		:pageUnit="30"
		:totalSize="groups.totalSize"
		:columns="partsInfoCols"
		:rows="partsInfo"
		:addRowDatas="addRowDatas"
		:stripe="false"
		selection
		@changedPage="changedPage"
		@changedRow="changedRow"
	>
		<template v-slot:actionsLeft>
			<!-- test code -->
			<sf-button v-if="isButton_(scrId, 'AD')" line icon="square-plue" :onClick="addAction">
				{{ getMessage_('MWCC000007') }}
			</sf-button>
			<sf-button v-if="isButton_(scrId, 'CU')" line icon="file" :onClick="saveAction">
				{{ getMessage_('MWCC000327') }}
			</sf-button>
			<sf-button color="error" line v-if="isButton_(scrId, 'CD')" icon="trash" :onClick="deleteAction">
				{{ getMessage_('MWCC000328') }}
			</sf-button>
		</template>
	</sf-data-table>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@/views/qms/PartsInfo/store/helpers';
import * as yup from 'yup';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			addRowDatas: [],
			currentTableData: null,
			rowSpanCount: 0
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			return this.partsInfo;
		},
		partsInfoCols() {
			return [
				{
					label: this.getMessage_('MWCC000420'), //번호
					prop: 'partsNo',
					minWidth: '100px',
					sortable: true,
					form: {
						type: 'input'
					}
				},
				{
					label: this.getMessage_('MWCC000462'), // 한국어
					prop: 'partsName',
					minWidth: '200px',
					sortable: true,
					form: {
						type: 'input'
						//isDisabled: this.isDisabled //추가된행은 편집을 못하게 한다.
					}
				},
				{
					label: this.getMessage_('MWCC000464'), // 영어
					prop: 'partsEnName',
					minWidth: '200px',
					sortable: true,
					form: {
						type: 'input'
					}
				},
				{
					label: this.getMessage_('MWCC000463'), // 중국어
					prop: 'partsZnName',
					minWidth: '300px',
					sortable: true,
					form: {
						type: 'input'
					}
				},
				{
					label: this.getMessage_('QWCC000915'), // 파트 크기
					prop: 'partsSize',
					minWidth: '140px',
					sortable: true,
					form: {
						type: 'input'
					}
				},
				{
					label: this.getMessage_('MWCC000106'), // 사용여부
					prop: 'useYn',
					minWidth: '100px',
					sortable: true,
					form: {
						type: 'select',
						options: this.gridUseYnList
						//isDisabled: this.isDisabled
					}
				}
			];
		},
		insVali() {
			return yup.array().of(
				yup.object().shape({
					partsNo: yup
						.string()
						.nullable()
						.required(this.$sf_formatString(this.getMessage_('MWCC000116'), [this.getMessage_('QWCC000904')]))
				})
			);
		}
	},
	methods: {
		...serviceMethods,
		resetTable() {
			this.$emit('Refresh');
		},
		isDisabled({ row }) {
			if (row.rowType && row.rowType === 'add') return false;
			else return true;
		},
		changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회햇기 때문에 중복 조회 하지 않도록 처리
				// return;
			}
			this.$emit('Refresh', currentPageVal, pageUnitVal);
		},
		addAction() {
			//행추가
			this.makeAddDatas();
			this.rows.unshift(...this.addRowDatas);
		},
		changedRow({ rows, changedRow }) {
			//console.log('[changedRow] rows: ', rows);
			//console.log('[changedRow] changedRow: ', changedRow);

			//console.log('값>>>>>>>>>', changedRow.tableState);

			let tmpStatus = changedRow.tableState;

			if (tmpStatus !== 'I') {
				changedRow.tableState = 'U';
			}
		},
		saveAction() {
			//저장
			const saveListRows = this.addListSaveRows_; //getters
			//console.log('값은', saveListRows);

			if (saveListRows.length < 1) {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('MWCC000103'),
					message: this.getMessage_('QWCC000914')
				}); //행을 선택해 주세요. / 선택된 데이터가 없습니다.
				return;
			}

			try {
				//벨리데이션체크
				this.insVali.validateSync(saveListRows);

				//컨펌창
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					title: this.getMessage_('MWCC000501'), //저장하시겠습니까?
					buttons: [{ title: this.getMessage_('MWCC000103'), clickFn: () => this.save(saveListRows) }] //저장
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
				return false;
			}
		},
		deleteAction() {
			//delete버튼
			//console.log('@@@@ delete action');
			const selected = this.$refs.partsInfoTable.getSelectedRows();

			if (selected.length < 1) {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('MWCC000109'),
					message: this.getMessage_('MWCC000110')
				}); //행을 선택해 주세요. / 선택된 데이터가 없습니다.
				return;
			}

			let delValiGb = false;
			this.$refs.partsInfoTable.multipleSelection.forEach(row => {
				if (row.tableState === 'I') {
					delValiGb = true;
				}
			});

			if (delValiGb === true) {
				this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC000917') });
				return false;
			}

			try {
				//컨펌창
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					title: this.getMessage_('MWCC000108'), //삭제하시겠습니까?
					buttons: [{ title: this.getMessage_('MWCC000107'), clickFn: () => this.remove(selected) }] //삭제
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
				return false;
			}
			// console.log('@@@@@@@@@@@@',selected);
		},
		resetSelection() {
			//체크박스 해제
			let checkedCount = document.getElementsByClassName('is-checked').length;
			for (let i = 0; i < checkedCount; i++) {
				document.getElementsByClassName('is-checked')[0].classList.remove('is-checked');
			}

			this.$emit('Refresh');
		},
		save(saveRows) {
			//console.log('@@@@ saveRows:', saveRows);

			let sendData = {
				status: 1,
				data: saveRows
			};
			/* 나중에 필요할지 몰라서 주석처리함.
			saveRows.forEach(row => {
				let pushSet = {
					varId: row.varId,
					varValue: row.varValue,
					rmk: row.rmk,
					tableState: row.tableState,
					rgtId: '',
					regDt: '',
					chgId: '',
					chgDt: ''
				};
				sendData.data.push(pushSet);
			});
			*/
			//console.log('@@@@ sendData: ', sendData);
			// return

			if (sendData.data != undefined && sendData.data.length > 0) {
				this.$sf_toggleLoading(true);
				this.setPartsInfo_(sendData)
					.then(value => {
						if (value.message != undefined && value.message != null) {
							this.$sf_toast({
								type: value.code === 0 ? 'ok' : 'error',
								message: this.getMessage_(value.messageCd)
							});
						}
						this.resetTable();
					})
					.catch(error => {
						this.$sf_toast({
							type: 'error',
							message: error.message
						});
						Promise.reject(error);
					})
					.finally(() => {
						this.$sf_toggleLoading(false);
					});
			}
		},
		remove(selected) {
			//console.log('@@@@ delete');
			let sendData = {
				status: 3,
				data: selected
			};

			this.$sf_toggleLoading(true);
			this.setPartsInfo_(sendData)
				.then(response => {
					if (response.message != undefined && response.message != null) {
						this.$sf_toast({
							type: response.code === 0 ? 'ok' : 'error',
							message: this.getMessage_(response.messageCd)
						});
					}
					this.resetSelection();
				})
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		makeAddDatas() {
			this.addRowDatas = [
				{
					rowType: 'add',
					partsNo: '',
					partsName: '',
					partsEnName: '',
					partsZnName: '',
					partsSize: '',
					useYn: 'Y',
					tableState: 'I'
				}
			];
		}
	}
};
</script>

<style></style>
